import { Grid, Checkbox } from "@material-ui/core";
import { PickupStopMarker } from "../../../../mapComponents/Markers";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { formatAddress } from "../../../../modules/Dispatch/utils/utils";

const PickupInfo = ({
  classes,
  stopDetails,
  isSelected,
  color,
  onPickupSelection,
}) => {
  let params = {
    stopNo: stopDetails.stopSequence,
    backgroundColor: color,
    borderColor: "white",
    textColor: "white",
    size: 22,
  };
  return (
    <Grid container className={classes.containerStyle} spacing={8}>
      <Grid item xs={1}>
        <Checkbox
          icon={<CheckBoxOutlineBlankIcon className={classes.sizeIcon} />}
          checkedIcon={<CheckBoxIcon className={classes.sizeIcon} />}
          classes={{
            root: classes.checkBoxStyle,
          }}
          color="primary"
          checked={isSelected}
          onClick={(e) => onPickupSelection(e, [stopDetails.pickupId.toLowerCase()])}
        />
      </Grid>
      <Grid item xs={6}>
        <div className={classes.assignShipperDetails}>
          <div className={classes.iconStyle}>
            <PickupStopMarker {...params} />
          </div>
          <div>
            <div className={classes.headerLabelStyle}>
              {stopDetails.shipperName}
            </div>
            <div className={classes.newDriverClass}>
              {formatAddress({
                address: stopDetails.address,
                address2: stopDetails.address2,
                city: stopDetails.city,
                state: stopDetails.state,
                zip: stopDetails.zip,
              })}
            </div>
            {stopDetails.previousDriver ? (
              <div className={classes.newDriverClass}>
                <b>PREVIOUS DRIVER:</b>{" "}
                {`${stopDetails.previousDriver?.driverName} (${stopDetails.previousDriver?.driverNumber})`}
              </div>
            ) : null}
          </div>
        </div>
      </Grid>
      <Grid item xs={2}>
        <div className={classes.headerLabelStyle}>ETA</div>
        <div className={classes.newDriverClass}>
          {stopDetails.estimatedTimeOfArrival}
        </div>
      </Grid>
      <Grid item xs={3}>
        <div className={classes.headerLabelStyle}>Pickup window</div>
        <div
          className={classes.newDriverClass}
        >{`${stopDetails.pickupReadyTime} - ${stopDetails.pickupCloseTime}`}</div>
      </Grid>
    </Grid>
  );
};
export default PickupInfo;
